// extracted by mini-css-extract-plugin
export default {"addressSection":"lQ-z","disabled":"mQ-z","sectionButtons":"nQ-z","logo":"oQ-z"};